import { Box, Typography } from "@mui/material";
import styles from "./shared.module.scss";

interface IMetric {
  index: number;
  icon: string;
  value: number;
  icon_desc: string;
  onClick?: () => void;
}

const Metric: React.FC<IMetric> = ({ index, icon, value, icon_desc, onClick }) => {
  return (
    <Box
      key={index}
      className={styles.metric}
      onClick={onClick}
      sx={{ cursor: "pointer" }}
    >
      <img src={icon} alt={icon_desc} className={styles.icon} />
      <Typography className={styles.value}>{value}</Typography>
    </Box>
  );
};

export default Metric;
